<template>
  <Listbox
    as="div"
    v-model="selected"
    multiple
    :disabled="props.disabled"
    @update:modelValue="handleSelected"
  >
    <div class="relative inline-block text-left">
      <ListboxButton
        class="inline-flex w-full justify-center rounded-sm border border-gray-300 bg-white text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-100 p-2 pl-2.5 focus:ring-0 focus:outline-0 focus:ring-offset-0 disabled:opacity-50"
      >
        <user-one class="-ml-1 mr-2 h-4 w-4 text-gray-500" />
        {{ t("admin.search.filters.assignee") }}
        <chevron-down class="-mr-1 ml-2 h-4 w-4" aria-hidden="true" />
      </ListboxButton>

      <transition
        leave-active-class="transition ease-in duration-100"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <ListboxOptions
          class="absolute z-10 mt-1 max-h-60 overflow-auto rounded-sm bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
        >
          <ListboxOption
            as="template"
            v-for="user in users"
            :key="user.id"
            :value="user"
            v-slot="{ active, selected }"
          >
            <li
              :class="[
                active ? 'text-gray-900 bg-gray-100' : 'text-gray-900',
                'relative cursor-pointer select-none py-2 pl-3 pr-9',
              ]"
            >
              <div class="flex items-center space-x-2">
                <input
                  class="h-4 w-4 rounded-xs border-gray-300 text-brand-900 focus:ring-0 focus:outline-0 focus:ring-offset-0 focus:ring-0"
                  type="checkbox"
                  :checked="selected"
                />
                <user-avatar :user="user" />
                <span
                  :class="['truncate font-normal', selected && 'font-semibold']"
                >
                  {{ user.fullname }}
                </span>
              </div>
            </li>
          </ListboxOption>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>
</template>

<script setup>
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/vue";
import ChevronDown from "@/Tailwind/Icon/ChevronDown.vue";
import UserOne from "@/Tailwind/Icon/Duotone/UserOne.vue";
import { useI18n } from "vue-i18n";
import { useUsers } from "@/Tailwind/Mixins/useUsers";
import { computed, defineEmits, defineProps, ref, watch } from "vue";
import UserAvatar from "@/Tailwind/Components/UserAvatar.vue";

const { t } = useI18n();

const emit = defineEmits(["click"]);

const props = defineProps({
  disabled: Boolean,
  tenants: Array,
  selected: Array,
});

const users = computed(() => useUsers(props.tenants));
const selected = ref(
  users.value.filter((user) => props.selected.includes(user.id))
);

watch(
  () => props.selected,
  () => {
    selected.value = users.value.filter((user) =>
      props.selected.includes(user.id)
    );
  }
);

function handleSelected(newUsers) {
  const newUserIds = newUsers.map((user) => user.id);
  // const previousUserIds = props.selected.filter(previousUserId => !users.value.map(({ id }) => id).includes(previousUserId));

  emit("click", [...newUserIds]);
}
</script>
